import { createAction } from 'redux-act';
// add email Type action
const addEmailTypeRequest = createAction('ADD_EMAILTYPE_REQUEST', data => data);
const addEmailTypeSuccess = createAction('ADD_EMAILTYPE_SUCCESS', data => data);
const addEmailTypeError = createAction('ADD_EMAILTYPE_ERROR');

// get email Type action
const getEmailTypeRequest = createAction('GET_EMAILTYPE_REQUEST', data => data);
const getEmailTypeSuccess = createAction('GET_EMAILTYPE_SUCCESS', data => data);
const getEmailTypeError = createAction('GET_EMAILTYPE_ERROR');

//add Email template action
const addEmailTemplateRequest = createAction('ADD_EMAILTEMPLATE_REQUEST', data => data);
const addEmailTemplateSuccess = createAction('ADD_EMAILTEMPLATE_SUCCESS', data => data);
const addEmailTemplateError = createAction('ADD_EMAILTEMPLATE_ERROR');

// get Email template action
const getEmailTemplateRequest = createAction('GET_EMAILTEMPLATE_REQUEST', data => data);
const getEmailTemplateSuccess = createAction('GET_EMAILTEMPLATE_SUCCESS', data => data);
const getEmailTemplateError = createAction('GET_EMAILTEMPLATE_ERROR');


// Update Email template action
const updateEmailTemplateRequest = createAction('Update_EMAILTEMPLATE_REQUEST', data => data);
const updateEmailTemplateSuccess = createAction('Update_EMAILTEMPLATE_SUCCESS', data => data);
const updateEmailTemplateError = createAction('Update_EMAILTEMPLATE_ERROR');

// Delete   action
const deleteEmailTemplateRequest = createAction('Delete_EMAILTEMPLATE_REQUEST', data => data);
const deleteEmailTemplateSuccess = createAction('Delete_EMAILTEMPLATE_SUCCESS', data => data);
const deleteEmailTemplateError = createAction('Delete_EMAILTEMPLATE_ERROR');

// Delete  action
const RemoveImageRequest = createAction('REMOVE_IMAGE_REQUEST', data => data);
const RemoveImageSuccess = createAction('REMOVE_IMAGE_SUCCESS', data => data);
const RemoveImageError = createAction('REMOVE_IMAGE_ERROR');

// Delete Department action
const AddActionTemplateRequest = createAction('Add_ACTION_REQUEST', data => data);
const AddActionTemplateSuccess = createAction('Add_ACTION_SUCCESS', data => data);
const AddActionTemplateError = createAction('Add_ACTION_ERROR');

const getActionTemplateRequest = createAction('GET_ACTION_REQUEST', data => data);
const getActionTemplateSuccess = createAction('GET_ACTION_SUCCESS', data => data);
const getActionTemplateError = createAction('GET_ACTION_ERROR');

const UpdataActionTemplateRequest = createAction('UPDATE_ACTION_REQUEST', data => data);
const UpdataActionTemplateSuccess = createAction('UPDATE_ACTION_SUCCESS', data => data);
const UpdataActionTemplateError = createAction('UPDATE_ACTION_ERROR');

const DeleteActionTemplateRequest = createAction('DELETE_ACTION_REQUEST', data => data);
const DeleteActionTemplateSuccess = createAction('DELETE_ACTION_SUCCESS', data => data);
const DeleteActionTemplateError = createAction('DELETE_ACTION_ERROR');

const GetActionTypeTemplateRequest = createAction('GET_ACTION_TYPE_REQUEST', data => data);
const GetActionTypeemplateSuccess = createAction('GET_ACTION_TYPE_SUCCESS', data => data);
const GetActionTypeemplateError = createAction('GET_ACTION_TYPE_ERROR');

// clear existing EmailTemplate action
const handleClearEmailTemplateStore = createAction('HANDLE_CLEAR_EMAILTEMPLATE_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addEmailTypeRequest,
    addEmailTypeSuccess,
    addEmailTypeError,

    getEmailTypeRequest,
    getEmailTypeSuccess,
    getEmailTypeError,

    addEmailTemplateRequest,
    addEmailTemplateSuccess,
    addEmailTemplateError,

    getEmailTemplateRequest,
    getEmailTemplateSuccess,
    getEmailTemplateError,

    updateEmailTemplateRequest,
    updateEmailTemplateSuccess,
    updateEmailTemplateError,

    deleteEmailTemplateRequest,
    deleteEmailTemplateSuccess,
    deleteEmailTemplateError,

    RemoveImageRequest,
    RemoveImageSuccess,
    RemoveImageError,
    
    AddActionTemplateRequest,
    AddActionTemplateSuccess,
    AddActionTemplateError,

    getActionTemplateRequest,
    getActionTemplateSuccess,
    getActionTemplateError,

    UpdataActionTemplateRequest,
    UpdataActionTemplateSuccess,
    UpdataActionTemplateError,

    DeleteActionTemplateRequest,
    DeleteActionTemplateSuccess,
    DeleteActionTemplateError,

    GetActionTypeTemplateRequest,
    GetActionTypeemplateSuccess,
    GetActionTypeemplateError,
    
    handleClearEmailTemplateStore,
    // toastMsgAction,
    
}